'use client';

import HeroSection from './HeroSection';
import GrowthAuditForm from './GrowthAuditForm';
import HowWeWorkSection from './HowWeWorkSection';
import GlobalReachSection from './GlobalReachSection';
import TrustedBySection from './TrustedBySection';
import { ArrowRight } from 'lucide-react';

interface StatItem {
  id: string;
  value: number;
  suffix: string;
  label: string;
  icon: string;
}

interface ClientLogo {
  id: string;
  name: string;
  logo: string;
  alt: string;
}

interface HomeInteractiveProps {
  heroData: {
    title: string;
    subtitle: string;
    ctaText: string;
    ctaLink: string;
    heroImage: string;
    heroImageAlt: string;
  };
  statsData: {
    title: string;
    subtitle: string;
    stats: StatItem[];
  };
  clientsData: {
    title: string;
    subtitle: string;
    clients: ClientLogo[];
  };
}

export default function HomeInteractive({
  heroData,
  statsData,
  clientsData,
}: HomeInteractiveProps) {
  return (
    <>
      <HeroSection
        title={heroData.title}
        // subtitle={heroData.subtitle}
        ctaText={heroData.ctaText}
        ctaLink={heroData.ctaLink}
        heroImage={heroData.heroImage}
        heroImageAlt={heroData.heroImageAlt}
      />
      <HowWeWorkSection />
      <GlobalReachSection
        title={statsData.title}
        subtitle={statsData.subtitle}
        stats={statsData.stats}
      />
      <TrustedBySection
        title={clientsData.title}
        subtitle={clientsData.subtitle}
        clients={clientsData.clients}
      />
      <GrowthAuditForm />
      {/* <div
        className="mt-10 mb-10 md:mt-14 md:mb-14 lg:mt-16 lg:mb-16 px-4 sm:px-6 lg:px-8 xl:px-10 text-center animate-slide-up"
        style={{ animationDelay: '400ms' }}
      >
        <div className="relative inline-flex flex-col md:flex-row items-center gap-4 md:gap-6 p-5 md:p-7 bg-white/85 backdrop-blur-xl rounded-[2rem] shadow-[0_24px_70px_-30px_rgba(39,78,255,0.35)] border border-white/80 max-w-[1500px] mx-auto w-full transition-all duration-500 hover:shadow-[0_28px_75px_-28px_rgba(250,0,172,0.45)] overflow-hidden">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_12%_20%,rgba(250,0,172,0.14),transparent_40%),radial-gradient(circle_at_85%_18%,rgba(39,78,255,0.14),transparent_42%),radial-gradient(circle_at_50%_88%,rgba(16,185,129,0.1),transparent_40%)]" />
          <div className="relative flex-1 text-center md:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-3 rounded-full border border-pink-200/70 bg-white/80 shadow-sm">
              <span className="w-2 h-2 rounded-full bg-pink-500 animate-pulse" />
              <span className="text-[10px] font-black uppercase tracking-[0.2em] text-pink-600">
                Strategy Call
              </span>
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-foreground mb-2 tracking-tight">
              Ready to transform your marketing?
            </h3>
            <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
              Let&apos;s discuss how we can help you grow with intelligent systems.
            </p>
          </div>
          <button className="relative group px-7 py-3.5 bg-gradient-to-r from-primary via-primary/90 to-secondary text-primary-foreground rounded-xl font-semibold text-sm md:text-base shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 transition-all duration-300 hover:-translate-y-1 active:scale-95 flex items-center justify-center gap-3 w-full md:w-auto overflow-hidden">
            <span className="relative z-10">Get Started</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1.5 transition-transform duration-300 relative z-10" />
            <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </button>
        </div>
      </div> */}
    </>
  );
}
